import { Component, OnInit } from '@angular/core';
import { BuzonService } from "../../servicios/buzon.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-quejatel',
  templateUrl: './quejatel.component.html',
  styleUrls: ['./quejatel.component.css']
})
export class QuejatelComponent implements OnInit {
  master: any = {
    anonimo: false,
    no_aplica: false,
    idsolicitud: 0,
    idsolicitud_tipo: 0,
    nombre: "",
    paterno: "",
    materno: "",
    calle: "",
    numero: "",
    colonia: "",
    telefono: "",
    correo: "",
    servidor: "",
    puesto: "",
    area: "",
    situacion: "",
    aviso_privacidad: false,
    consentimiento_datos: false
  };

  forma: any = { ...this.master };

  tipos: any = [];
  folio = 0;
  nombre = "";
  archivos: any = [];

  siteKey = environment.KEY_CAPTCHA;
  type = "image";
  theme = "Light";
  size = "inline";
  lang = "es";
  captcha = false;
  loading = true;

  constructor(private _buzonService: BuzonService,
    private modalService: NgbModal) { }

  ngOnInit() {
    this.getTipos();
  }

  enviar(m) {
    this.loading = true;

    if (this.forma.idsolicitud_tipo == 0) {
      Swal.fire({
        icon: "error",
        title: "Aviso.",
        text: "Error, debe seleccionar un tipo de solicitud."
      });
      return;
    }

    this._buzonService.enviarSolicitud(this.forma).then((response: any) => {
        this.folio = response.folio;
        this.forma.idsolicitud = response.idsolicitud;
        let i = 0;

        if (this.archivos.length > 0) {
          Array.from(this.archivos).forEach(archivo => {
            this._buzonService
              .enviarArchivo({ idsolicitud: this.forma.idsolicitud }, archivo)
              .then((response: any) => {
                  i = i + 1;
                  // tslint:disable-next-line: triple-equals
                  if (this.archivos.length == i) {
                    this.descargar();
                    m.show();
                  }
                },
                error => { }
              );
          });
        } else {
          this.descargar();
          m.show();
        }
      },
      error => { }
    );
  }


  // enviarOriginal(m) {
  //   this.loading = true;

  //   if (this.forma.idsolicitud_tipo == 0) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Aviso.",
  //       text: "Error, debe seleccionar un tipo de solicitud."
  //     });
  //     return;
  //   }

  //   this._buzonService.enviarSolicitud(this.forma).subscribe(
  //     response => {
  //       this.folio = response.folio;
  //       this.forma.idsolicitud = response.idsolicitud;
  //       let i = 0;

  //       if (this.archivos.length > 0) {
  //         Array.from(this.archivos).forEach(archivo => {
  //           this._buzonService
  //             .enviarArchivo({ idsolicitud: this.forma.idsolicitud }, archivo)
  //             .subscribe(
  //               response => {
  //                 i = i + 1;
  //                 // tslint:disable-next-line: triple-equals
  //                 if (this.archivos.length == i) {
  //                   this.descargar();
  //                   m.show();
  //                 }
  //               },
  //               error => { }
  //             );
  //         });
  //       } else {
  //         this.descargar();
  //         m.show();
  //       }
  //     },
  //     error => { }
  //   );
  // }


  

  // getTipos() {
  //   this._buzonService.getSolicitudesTipos().subscribe(
  //     response => {
  //       this.tipos = response.registros;
  //       this.loading = false;
  //     },
  //     error => {
  //       this.tipos = [];
  //     }
  //   );
  // }

  getTipos() {
    this._buzonService.getSolicitudesTipos().then((data: any) => {
      this.tipos = data;
      
    })
   }

  descargar() {
    this._buzonService.getSolicitudPdf(this.forma.idsolicitud).then((data: any) => {
        // this.tipos = response;
        this.loading = false;
      },
      error => {
        // this.tipos = [];
      }
    );
  }

  limpiar() {
    this.forma = { ...this.master };
  }

  cambioImg(event) {
    let files = event.target.files;
    console.log(files)
    this.nombre = "";
    if (files.length > 6) {
      Swal.fire("", "El número máximo de archivos permitidos son 6", "info");
      // c.show();
    } else {
      this.archivos = files;
      if (files.length > 0) {
        this.nombre = files.length + " archivos han sido seleccionados.";
      }
    }
    // *****
  }

  handleSuccess(e) {
    this.captcha = true;
  }

  handleExpire(e) {
    this.captcha = false;
  }

}
